import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_session_starter = _resolveComponent("session-starter")!
  const _component_login = _resolveComponent("login", true)!
  const _component_message = _resolveComponent("message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.sessionId)
      ? (_openBlock(), _createBlock(_component_session_starter, {
          key: 0,
          platform: _ctx.platform,
          "session-id": _ctx.sessionId,
          "onUpdate:sessionId": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sessionId) = $event))
        }, null, 8, ["platform", "session-id"]))
      : (_ctx.sessionId && !_ctx.error)
        ? (_openBlock(), _createBlock(_component_login, {
            key: 1,
            "session-id": _ctx.sessionId,
            platform: _ctx.platform,
            onError: _ctx.onError,
            onSuccess: _ctx.onLogin
          }, null, 8, ["session-id", "platform", "onError", "onSuccess"]))
        : (_openBlock(), _createBlock(_component_message, {
            key: 2,
            type: "warning"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" A problem occurred while logging in to " + _toDisplayString(_ctx.platform) + ". A member of our support team will contact you by email shortly to help you import your " + _toDisplayString(_ctx.platform) + " posts. ", 1)
            ]),
            _: 1
          }))
  ]))
}